import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import A from 'wanderu-component-react-router-link';
import { localize } from 'wanderu-i18n';

import baseAppConfig from 'wanderu-shellapp/src/config/baseApp.locales';

import Events from '../events/AccountEvents';

import styles from './AccountLinks.scss';

const ACCOUNT_LINKS = [
    { href: '/account/mytrips', textKey: 'my-trips-menu', seLabel: 'my_trips' },
    { href: '/account/settings', textKey: 'account', seLabel: 'account' },
    { href: '/account/points', textKey: 'points', seLabel: 'points' },
];

function AccountLinks(props) {
    const {
        capabilities,
        linkClassName,
        isLoggedIn,
        onClick,
        onLogOut,
        navType,
        t,
    } = props;

    const clickButton = (seLabel) => (e) => {
        onClick(e);
        Events.clicked({
            label: seLabel,
            navType,
        });
    };

    const logOut = (e) => {
        onLogOut(e);
        Events.clicked({
            label: 'log_out',
            navType,
        });
    };

    return (
        <div className={styles.container}>
            {ACCOUNT_LINKS.map(({ href, textKey, seLabel }) => {
                if (textKey === 'points' && !capabilities.includes('points')) {
                    return null;
                }

                return (
                    <A
                        className={classNames(styles.link, linkClassName)}
                        href={href}
                        key={href}
                        onClick={clickButton(seLabel)}
                        rel="nofollow"
                    >
                        {t(textKey)}
                    </A>
                );
            })}
            {isLoggedIn && (
                <span
                    className={classNames(styles.link, linkClassName)}
                    onClick={logOut}
                >
                    {t('log-out')}
                </span>
            )}
        </div>
    );
}

AccountLinks.propTypes = {
    capabilities: PropTypes.arrayOf(PropTypes.string),
    linkClassName: PropTypes.string,
    isLoggedIn: PropTypes.bool,
    onClick: PropTypes.func,
    onLogOut: PropTypes.func,
    t: PropTypes.func.isRequired,
};

AccountLinks.defaultProps = {
    capabilities: [],
    linkClassName: '',
    isLoggedIn: false,
    onClick() {},
    onLogOut() {},
};

export { AccountLinks };
export default localize(AccountLinks, ['t'], baseAppConfig.namespace);
